import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    defaultUseCaseResource,
    UseCaseMutationResourceSchema,
    type UseCaseResource,
    useUseCaseActions,
} from '../../../../../resource/resources/artifacts/use_case/useCaseResource';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { creationDialogOnSuccess } from '../../../../util/utilFunctions';
import { UseCaseContent } from './UseCaseContent';

export const UseCaseCreationDialog = ({
    onClose,
    parentId,
    autoGeneratedProps,
    onCreated,
}: {
    onClose: () => void;
    parentId: string;
    autoGeneratedProps?: UseCaseResource;
    onCreated?: (id: string, objectId: string) => void;
}) => {
    const useCaseActions = useUseCaseActions();
    const addUseCase = useCaseActions.useAddResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: UseCaseMutationResourceSchema,
        defaultValues: {
            ...defaultUseCaseResource,
            ...autoGeneratedProps,
        },
        submitHandler: async (data) => {
            await addUseCase.mutateAsync(
                {
                    resource: data,
                    parentId,
                },
                {
                    onSuccess: creationDialogOnSuccess(onCreated, onClose),
                }
            );
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Create Use Case'}
            resourceType={ResourceType.USE_CASE}
        >
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={true}>
                <UseCaseContent form={form} formNames={formNames} readOnly={false} />
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};
